import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import templateData, { localsMessages } from '../utility/getTemplateData';
import * as AppActions from '../actions/AppActions';
import AppStore from '../stores/AppStore';
import { addClass, removeClass } from '../utility/domUtils';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import isEmpty from 'lodash/isEmpty';
import * as FPT from '../utility/fpt';
import { EVENT_NAME } from '../utility/constants';
import { IconButton, TextArea, Divider, grey500 } from '@paypalcorp/pp-react';
import NoteFieldError from './NoteFieldError';

let messages = localsMessages('common/note');
const MAX_CHAR_LIMIT = 250;

function NoteComponent(props) {
  let { label = '', error: { lengthLimit = '' } = {} } = messages.note;

  let providedLabel = label;
  if (templateData.charityNoteEnabled && templateData.charityNoteLabel) {
    providedLabel = templateData.charityNoteLabel;
  }

  if (props.label) {
    providedLabel = props.label;
  }

  const [donationNote, setDonationNote] = useState(
    AppStore.getDonationNote() || templateData.donationNote || ''
  );
  const initialNoteLabel = isEmpty(donationNote) ? providedLabel : donationNote;

  const [showLabel, setShowLabel] = useState(true);
  const [showError, setShowError] = useState(false);
  const [noteLabel, setNoteLabel] = useState(initialNoteLabel);
  const textAreaEl = useRef(null);

  useEffect(() => {
    if (!showLabel && !isEmpty(textAreaEl)) {
      textAreaEl.current.focus();
    }
  }, [showLabel]);

  const directionality = templateData.contextLocalityDir;

  const handleClick = () => {
    if (isExternalFlow()) {
      FPT.trackEventName(EVENT_NAME.DW_GIVING_DONATE_SETUP_COMMENT_PRESSED);
    }
    FPT.trackDonationAmount();
    FPT.trackLinkClick('note_pad');
    setShowLabel(false);
  };

  const handleBlur = (event) => {
    const note = event.target.value;

    // Remove all whitespaces
    if (!isEmpty(note) && !isEmpty(note.trim())) {
      AppActions.changeNote({ note });
      setNoteLabel(note);
    } else {
      AppActions.changeNote({ note: '' });
      setNoteLabel(providedLabel);
    }
    setShowLabel(true);
  };

  const showNoteFieldError = () => {
    setShowError(true);
  };

  const hideNoteFieldError = () => {
    setShowError(false);
  };

  const handleOnChange = (event) => {
    const value = event.target.value;
    setDonationNote(value);

    if (value && value.length >= MAX_CHAR_LIMIT) {
      addClass('.note_wrap', ['animated', 'shake']);
      setTimeout(() => {
        removeClass('.note_wrap', ['animated', 'shake']);
      }, 1000);
      showNoteFieldError();
    } else {
      hideNoteFieldError();
    }
  };

  return (
    <div className="client_note_row">
      <div
        className={`ppvx-row ${
          isExternalFlow() ? 'client_note_wrapper' : 'donate_note_wrapper'
        }`}
      >
        {showLabel ? (
          <label
            htmlFor="note"
            onClick={handleClick}
            style={{ color: grey500 }}
          >
            <IconButton
              iconName={isExternalFlow() ? 'add' : 'edit'}
              style={{ color: grey500 }}
            >
              {noteLabel}
            </IconButton>
            <span aria-hidden="true">{noteLabel}</span>
          </label>
        ) : (
          <div className="note_wrap">
            <TextArea
              id="note"
              name="note"
              maxRows={4}
              minRows={4}
              value={donationNote}
              showCharacterCounter
              maxLength={MAX_CHAR_LIMIT}
              maxCharacters={MAX_CHAR_LIMIT}
              onChange={handleOnChange}
              onBlur={handleBlur}
              ref={textAreaEl}
              errorText={showError ? lengthLimit : null}
              label={providedLabel}
              dir={directionality}
            />
          </div>
        )}

        {showError && showLabel && <NoteFieldError errorText={lengthLimit} />}
      </div>
      {isExternalFlow() && <Divider className="client_note_divider" />}
    </div>
  );
}

NoteComponent.propTypes = {
  label: PropTypes.string,
};

export default NoteComponent;
